import mime from "mime"
import { toast } from "sonner"

const MAX_CANDIDATE_NAME_LENGTH = 80

export const buildLeadProfilePdfFileName = (candidateName?: string): string => {
    let safeName = candidateName?.trim() ?? ""
    safeName = safeName.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_.-]/g, "")
    if (!safeName) {
        safeName = "Candidate"
    } else if (safeName.length > MAX_CANDIDATE_NAME_LENGTH) {
        safeName = safeName.slice(0, MAX_CANDIDATE_NAME_LENGTH)
    }

    const currentDate = new Date().toISOString().slice(0, 10)
    return `${safeName}_${currentDate}.pdf`
}

export const openFile = async (url: string, downloadFileName?: string) => {
    const fileUrlBase = url.split("?")[0]
    const fileNameFromUrl = fileUrlBase.substring(fileUrlBase.lastIndexOf("/") + 1)
    const resolvedFileName = downloadFileName ?? fileNameFromUrl
    const extension = resolvedFileName.substring(resolvedFileName.lastIndexOf(".") + 1)

    try {
        const response = await fetch(url)
        const blob: Blob = await response.blob()
        const mimeType = mime.getType(extension) ?? undefined
        const file = new Blob([blob], { type: mimeType })
        const fileUrl = URL.createObjectURL(file)

        if (downloadFileName) {
            const anchorElement = document.createElement("a")
            anchorElement.href = fileUrl
            anchorElement.download = resolvedFileName
            anchorElement.click()
        } else {
            window.open(fileUrl, "_blank")
        }

        setTimeout(() => URL.revokeObjectURL(fileUrl), 2000)
    } catch (error) {
        toast.error("Failed to download the file")
    }
}
